import { render, staticRenderFns } from "./InviteDetail.vue?vue&type=template&id=408172a2&scoped=true"
import script from "./InviteDetail.vue?vue&type=script&lang=js"
export * from "./InviteDetail.vue?vue&type=script&lang=js"
import style0 from "./InviteDetail.vue?vue&type=style&index=0&id=408172a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408172a2",
  null
  
)

export default component.exports